var __TEMP__ = require('./_baseAt.js');var baseAt = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_flatRest.js');var flatRest = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates an array of values corresponding to `paths` of `object`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Array} Returns the picked values.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _.at(object, ['a[0].b.c', 'a[1]']);
 * // => [3, 4]
 */
var at = flatRest(baseAt);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = at;
